// extracted by mini-css-extract-plugin
export var backdropBlur = "_co-0";
export var contentCard = "_co-5";
export var frame = "_co-2";
export var image = "_co-4";
export var imagePane = "_co-3";
export var modal = "_co-1";